// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"cK-z","carouselContainer":"dK-z"};